import type { NotificationType } from 'src/lib/notifications';

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { showNotification } from 'src/lib/notifications';

/**
 * Hook to handle notification messages from location state
 * Must be used within Router context
 */
export function useLocationStateMessages() {
  const location = useLocation();

  useEffect(() => {
    if (location.state && typeof location.state === 'object' && 'message' in location.state) {
      const message = location.state.message as string;
      const type = (location.state.type as NotificationType) || 'info';

      if (message) {
        // Small delay to ensure components are mounted
        setTimeout(() => {
          showNotification(message, type);
        }, 100);
      }
    }
  }, [location]);

  return null;
}

/**
 * Component to handle location state messages
 * Must be used within Router context
 */
export function LocationStateHandler() {
  useLocationStateMessages();
  return null;
}
